import {userHovercardPath} from '@github-ui/paths'
import {RepoIcon} from '@primer/octicons-react'
import {Label, Link} from '@primer/react'
import {Octicon} from '@primer/react/deprecated'
import type {BetterSystemStyleObject} from '@primer/styled-react'
import {Box} from '@primer/styled-react'
import type {FC} from 'react'
import {useFragment} from 'react-relay'
import {graphql} from 'relay-runtime'

import {LABELS} from '../../constants/labels'
import type {RepositoryPill$key} from './__generated__/RepositoryPill.graphql'
import styles from './RepositoryPill.module.css'

const RepositoryPillFragment = graphql`
  fragment RepositoryPill on Issue {
    repository {
      name
      owner {
        login
      }
      isPrivate
    }
  }
`

export type RepositoryPillProps = {
  repositoryPillData: RepositoryPill$key
  sx?: BetterSystemStyleObject
  isSmall?: boolean
}

export const SmallRepositoryPill: FC<RepositoryPillProps> = props => <RepositoryPill {...props} isSmall />

export function RepositoryPill({repositoryPillData, sx, isSmall = false}: RepositoryPillProps) {
  const {repository} = useFragment(RepositoryPillFragment, repositoryPillData)
  const repoOwner = repository.owner.login
  const repoName = repository.name

  const link = (
    <Box
      sx={{
        height: isSmall ? undefined : '32px',
      }}
      className={styles.repositoryInfoContainer}
    >
      {!isSmall && <Octicon icon={RepoIcon} className={styles.repositoryIcon} />}{' '}
      {/* 2px to achieve visual alignment */}
      <Link
        href={`/${repoOwner}`}
        data-hovercard-url={userHovercardPath({owner: repoOwner})}
        className={styles.ownerLink}
      >
        {repoOwner}
      </Link>
      <span>/</span>
      <Link href={`/${repoOwner}/${repoName}`} className={styles.repositoryNameLink}>
        {repoName}
      </Link>
    </Box>
  )

  if (isSmall) {
    return link
  }

  return (
    <Box
      sx={{
        ...sx,
      }}
      className={styles.smallRepositoryPill}
    >
      {link}
      <Label size="small" data-watch-overflow className={styles.repositoryLabel}>
        {repository.isPrivate ? LABELS.private : LABELS.public}
      </Label>
    </Box>
  )
}

try{ RepositoryPill.displayName ||= 'RepositoryPill' } catch {}